const DiamondRow = () => {
  return (
    <div className="flex flex-row gap-[2px]">
      {Array.from({ length: 15 }).map((_, index) => (
        <div
          key={index}
          className="w-[6px] h-[6px] rotate-45 rounded-[1px] bg-gray-300"
        />
      ))}
    </div>
  )
}

export default DiamondRow
